<!--
 * @Description: 
 * @Date: 2024-01-11 14:07:13
-->
<template>
  <div>
    <div
      style="
        font-size: 28px;
        text-align: center;
        font-weight: bold;
        margin-bottom: 32px;
      "
    >
      个案处理摘要
    </div>
    <div v-html="html"></div>
    <div
      style="
        font-size: 26px;
        border: 2px dashed #c0bec7;
        margin-top: 32px;
        padding: 24px 32px;
      "
    >
      根据个案处理摘要显示，“性别”中“男”的个案数为10个，有效百分比为47.62%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为10个，总计个案数百分比为100.00%；“性别”中“女”的有效个案数为11个，有效百分比为52.38%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为11个，总计个案数百分比为100.00%；“年龄”中“18-30岁”的个案数为6个，有效百分比为28.57%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为6个，总计个案数百分比为100.00%，“年龄”中“31-40岁”的有效个案数为8个，有效百分比为38.10%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为8个，总计个案数百分比为100.00%，“年龄”中“41岁以上”的有效个案数为7个，有效百分比为33.33%，缺失个案数为0个，缺失百分比为0.00%，总计个案数为7个，总计个案数百分比为100.00%。
    </div>
  </div>
</template>

<script setup lang="tsx">
import { defineProps } from 'vue';
import { useTable } from '../../../hooks/use-table';

const props = defineProps<{
  tableHeaderList: any;
  tableDataList: Array<{ [key: string]: Array<string> }>;
}>();

const className = 'case-table-1';
const attrs = `border='0' bordercolor='#C0BEC7'`;
const { createTable } = useTable(props.tableHeaderList, className, attrs);
const html = createTable(props.tableDataList);
</script>
<style lang="scss">
@import '../../../styles/custom-table.scss';
$border: 2pt solid #c0bec7;
.case-table-1 {
  thead {
    tr {
      th {
        background: var(--theme-color-1-10);
        &.empty {
          & > div {
            background: #fff !important;
          }
          & + .empty {
            & > div {
              border-left-color: #fff;
            }
          }
        }
        & > div {
          border-left: $border;
          border-bottom: $border;
        }
        &:last-child {
          div {
            border-right: $border;
          }
        }
      }
      &:nth-child(odd) {
        th {
          background: var(--theme-color-1);
          & > div {
            color: #fff;
          }
        }
      }
      &:first-child {
        th {
          div {
            border-top: $border;
          }
        }
      }
    }
  }
  tbody {
    tr {
      td {
        &:last-child {
          div {
            border-right: $border;
          }
        }
        &:nth-child(2) {
          background: var(--theme-color-1-10);
        }
        & > div {
          border-left: $border;
          border-bottom: $border;
        }
      }
    }
  }
}
</style>
